import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const AdminSignature = lazy(() => import("@/pages/admin/AdminSignature"));

export const Route = createFileRoute("/admin/signature")({
  component: AdminSignature,
});
